export default {
      id: "deadline-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#deadline",
      toString: function () {
        return this.url;
      }
    }